var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: ["box-typical", "page-builder", _vm.show || "hide"] },
    [
      _c(
        "div",
        {
          staticClass: "tab-content",
          staticStyle: { overflow: "visible", height: "auto" }
        },
        [
          _c(
            "div",
            {
              staticClass: "clearfix tab-pane active",
              attrs: { role: "tabpanel", id: "tab-contact-1" }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4 multi-select" },
                  [
                    _c("h4", { staticClass: "mt-0" }, [_vm._v("Panels")]),
                    _vm._v(" "),
                    _vm.initialized
                      ? _c(
                          "draggable",
                          {
                            staticClass: "list-group overflow-y-hidden",
                            on: { end: _vm.changePriority },
                            model: {
                              value: _vm.items,
                              callback: function($$v) {
                                _vm.items = $$v
                              },
                              expression: "items"
                            }
                          },
                          [
                            _vm._l(_vm.items, function(item) {
                              return _c(
                                "a",
                                {
                                  key: item.id,
                                  class: [
                                    "list-group-item",
                                    "list-group-item-action",
                                    item.id == _vm.currentPanelId
                                      ? "selected"
                                      : ""
                                  ],
                                  on: {
                                    click: function($event) {
                                      return _vm.changePanel(item.id)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "i",
                                    { staticClass: "material-icons drag-icon" },
                                    [_vm._v("view_headline")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "list-group-item-label" },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(item.name)
                                      ),
                                      _c("br"),
                                      _c("small", [
                                        _vm._v(_vm._s(item.description))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  item.id != 0
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-white btn-rounded btn-sm mt-1_",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              return _vm.deletePanel(item)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("delete_outline")]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-center mt-2" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-rounded btn-icon btn-sm btn-success",
                                  attrs: { type: "button" },
                                  on: { click: _vm.openCreateModal }
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("add")
                                  ]),
                                  _vm._v("Create New Panel")
                                ]
                              )
                            ])
                          ],
                          2
                        )
                      : _c(
                          "div",
                          { staticStyle: { padding: "8rem" } },
                          [_c("vue-spinner")],
                          1
                        )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-8" }, [
                  _c(
                    "div",
                    { staticClass: "page-col-right-in" },
                    [
                      _c("h4", { staticClass: "mt-0" }, [
                        _vm._v(
                          "\n                            Content\n                            "
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "btn-group btn-group-toggle float-right border"
                          },
                          [
                            _c(
                              "button",
                              {
                                class: [
                                  "btn",
                                  "btn-trans",
                                  "px-2",
                                  !_vm.previewMode ? "active" : ""
                                ],
                                on: {
                                  click: function() {
                                    return (_vm.previewMode = null)
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("edit")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                class: [
                                  "btn",
                                  "btn-trans",
                                  "px-2",
                                  _vm.previewMode == "desktop" ? "active" : ""
                                ],
                                on: {
                                  click: function() {
                                    return (_vm.previewMode = "desktop")
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("computer")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                class: [
                                  "btn",
                                  "btn-trans",
                                  "px-2",
                                  _vm.previewMode == "mobile" ? "active" : ""
                                ],
                                on: {
                                  click: function() {
                                    return (_vm.previewMode = "mobile")
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("smartphone")
                                ])
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.previewMode
                        ? _c("div", { staticClass: "tab-content" }, [
                            _c("iframe", {
                              class: [
                                "layout-preview",
                                "mt-3",
                                "layout-preview-" + _vm.previewMode
                              ],
                              attrs: {
                                id: "previewIframe",
                                scrolling: "no",
                                src: _vm.getPanelPreviewLink()
                              }
                            })
                          ])
                        : [
                            _vm.currentPanelId == 0
                              ? [
                                  _vm._t("name"),
                                  _vm._v(" "),
                                  _vm._t("intro"),
                                  _vm._v(" "),
                                  _vm._t("heading"),
                                  _vm._v(" "),
                                  _vm._t("subheading"),
                                  _vm._v(" "),
                                  _vm._t("content")
                                ]
                              : _c("form-component", {
                                  key: _vm._.get(_vm.currentPanel, "id"),
                                  attrs: {
                                    timestamp: _vm.timestamp,
                                    type: _vm._.get(_vm.currentPanel, "type"),
                                    id: _vm._.get(_vm.currentPanel, "id"),
                                    parent: _vm.parent,
                                    attributes: _vm._.get(
                                      _vm.currentPanel,
                                      "attributes"
                                    ),
                                    meta: _vm._.get(_vm.currentPanel, "meta"),
                                    schema: _vm._.get(
                                      _vm.currentPanel,
                                      "schema.attributes"
                                    ),
                                    config: _vm.formConfig,
                                    resourceParams: _vm.resourceParams,
                                    changeUrl: _vm.changeUrl,
                                    changeSection: _vm.changeSection,
                                    changeQuery: _vm.changeQuery,
                                    addNotification: _vm.addNotification,
                                    createData: _vm.doNothing,
                                    updateData: _vm.doNothing,
                                    deleteData: _vm.doNothing,
                                    onInitialized: _vm.doNothing,
                                    onCreated: _vm.doNothing,
                                    onChanged: _vm.editPanel,
                                    onUpdated: _vm.doNothing,
                                    onDeleted: _vm.doNothing
                                  }
                                })
                          ]
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            visible: _vm.showCreateModal,
            "header-class": "border-0",
            "body-class": "p-0",
            size: "lg",
            title: ""
          },
          on: {
            ok: _vm.addPanel,
            cancel: _vm.closeCreateModal,
            hide: function() {
              return (_vm.showCreateModal = false)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "page-builder-modal" },
            [
              _c(
                "b-card",
                { attrs: { "no-body": "" } },
                [
                  _c(
                    "b-tabs",
                    {
                      attrs: { card: "", "nav-wrapper-class": "nav-tabs-two" }
                    },
                    [
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: "Choose from panel library",
                            active: ""
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "page-builder-modal-header" },
                            [
                              _c("label", {}, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.initialized
                                        ? "Select panel:"
                                        : "Loading..."
                                    )
                                  )
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "page-builder-modal-in" },
                            [
                              _vm.initialized
                                ? _c("radio-list-component", {
                                    attrs: {
                                      value: _vm._.get(_vm.panelOption, "id"),
                                      options: _vm.panelOptions,
                                      config: _vm.globalPanelConfig
                                    },
                                    on: { input: _vm.selectPanel }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-tab", { attrs: { title: "Create new panel" } }, [
                        _c(
                          "div",
                          { staticClass: "page-builder-modal-header" },
                          [
                            _c("label", {}, [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.initialized
                                      ? "Select panel type:"
                                      : "Loading..."
                                  )
                                )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "page-builder-modal-in" },
                          [
                            _vm.initialized
                              ? _c("radio-list-component", {
                                  attrs: {
                                    options: _vm.panelTypes,
                                    config: _vm.localPanelConfig
                                  },
                                  on: { input: _vm.selectPanelType }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01eeb824", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01eeb824","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/PageBuilderComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-01eeb824","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/PageBuilderComponent.vue
// module chunks = 0